import { instance } from "api/apiBase";
import { PaginatedResponse } from "shared/types";
import { Contact, ContactDetailed } from "views/contacts/types";

interface GetContactsParams {
  page?: number;
  per_page?: number;
  search?: string;
  email?: string;
  phone?: string;
  order_by?: "created_at" | "updated_at";
  order_direction?: "asc" | "desc";
}

// GET /portal/v1/contacts
export const getContacts = async (
  params: GetContactsParams
): Promise<PaginatedResponse<Contact>> => {
  return instance
    .get("/portal/v1/contacts", { params })
    .then((res) => res.data as PaginatedResponse<Contact>);
};

// GET /portal/v1/contacts/:id
export const getContactById = async (id: string): Promise<ContactDetailed> => {
  return instance
    .get(`/portal/v1/contacts/${id}`)
    .then((res) => res.data as ContactDetailed);
};

// POST /portal/v1/contacts/check_duplicates
export interface DuplicateContact {
  type: "email" | "phone";
  value: string;
  normalized_value: string;
  contact: {
    id: number;
    first_name: string;
    last_name: string;
  };
}

export const checkDuplicateContacts = async (params: {
  emails?: string[];
  phones?: string[];
}): Promise<{ duplicates: DuplicateContact[] }> => {
  return instance
    .post("/portal/v1/contacts/check_duplicates", params)
    .then((res) => res.data as { duplicates: DuplicateContact[] });
};

// PUT /portal/v1/contacts/:id
export const updateContact = async (
  id: string,
  data: { first_name?: string; last_name?: string }
): Promise<ContactDetailed> => {
  return instance
    .put(`/portal/v1/contacts/${id}`, data)
    .then((res) => res.data as ContactDetailed);
};
